module.exports = __webpack_public_path__ + "static/media/gryphonhouse-logo-gold.4576383e.svg";